import { render } from "./PersonalData.vue?vue&type=template&id=bb9bd902&scoped=true"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"

import "./PersonalData.vue?vue&type=style&index=0&id=bb9bd902&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9bd902"]])

export default __exports__